export enum TradeStatusEnum {
  Undefined = 0,
  Aberto = "Aberto",
  Rejeitado = "Rejeitado",
  Aprovado = "Aprovado",
  Manual = "Manual",
  Aguardando = "Aguardando",
  Rejeitado300 = "Rejeitado300",
  RerunBCheck = "RerunBCheck",
  Pendencia = "Pendencia",
  PendenciaEnviada = "PendenciaEnviada"
}



// WEBPACK FOOTER //
// ./src/services/interfaces/TradeStatusEnum.ts